import css from 'styled-jsx/css';
import { colors, typography } from '../../config/styles';
import { svgUrl } from '../../utils/staticUrls';

const ProPriceStyles = css`
  .pro-prices-container {
    margin-top: 10px;
  }

  .pro-prices-icon-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 2px;
    margin-bottom: 4px;
    &.pe {
      flex-direction: column;
    }
  }

  .pro-prices-icon-pe {
    background-image: url(${svgUrl('proPrice_sope.svg')});
    width: 106px;
    height: 17px;
    display: inline-block;
    background-repeat: no-repeat;
  }

  .pro-prices-icon-cl {
    background-color: ${colors.red.shade7};
    padding: 2px;
    height: 32px;
    display: flex;
    align-items: center;
    letter-spacing: -0.22px;
    width: 70px;
  }

  .pro-prices-text-cl {
    color: ${colors.white.shade1};
    font-size: ${typography.sm};
    line-height: 14px;
    font-family: Lato, sans-serif;
    font-weight: 700;
    letter-spacing: -0.3px;
  }

  .pro-prices-badge {
    height: 16px;
    width: auto;
    background-color: ${colors.black.shade13};
    border: 0.5px solid #fd0;
    border-radius: 0 4px 0 0;
    padding: 0 3px;
    font-size: ${typography.sm};
    font-weight: 700;
    color: ${colors.white.shade1};
    letter-spacing: -0.22px;
    display: flex;
    align-items: center;
    &.cl {
      background-color: ${colors.red.shade7};
      border: none;
      border-radius: 0;
      height: 32px;
      font-family: Lato, sans-serif;
      font-size: ${typography.sm};
      padding: 2px;
    }
  }

  .unit-pro-price {
    font-size: ${typography.base};
    font-weight: 400;
    line-height: normal;
    color: ${colors.gray.shade52};
  }

  .pro-price {
    font-size: ${typography.lg2};
    font-weight: 400;
    line-height: 20px;
  }

  .pro-price-no-unit {
    font-size: ${typography.base};
    font-weight: 400;
    line-height: normal;
    color: ${colors.gray.shade52};
  }
`;

export { ProPriceStyles };
